import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { isoDay } from "@/components/sites/bookings/helpers";
import { useEditor } from "../useEditorState";
import { StepHours, StepType, TYPES, typeDefaults } from "./WizardSteps";
import { StepCustomer, StepSummary, bodyOf } from "./WizardMore";
import { rowsProblem } from "@/components/sites/bookings/CustomerFormEditor";

const STEPS = ["Tipo", "Giorni e orari", "Dati cliente", "Anteprima e salva"];
const start = (mode) => {
  const type = mode === "table" ? "table" : "appointment";
  return { ...typeDefaults(type), name: TYPES[type].name, nameTouched: false, mode, parallel: 1, covers: 40, perDay: false, week: {},
    price: "", showEnd: true, notes: "optional", fields: [] };
};

export default function BookingWizard({ c, mode, askMode, onClose, onDone }) {
  const ed = useEditor();
  const [i, setI] = useState(0);
  const [f, setF] = useState(() => start(mode));
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const set = (p) => setF((x) => ({ ...x, ...p }));
  const ok = [f.name.trim(), f.perDay || (f.days.length && f.hours.trim()), !rowsProblem(f.rows), true][i];
  const save = async () => {
    setBusy(true);
    try {
      const { data: svc } = await ed.api.post(`/t/${c.tid}/booking/services`, bodyOf(f, c.site.id));
      const a = new Date(), b = new Date(Date.now() + 6 * 864e5);
      const { data: slots } = await ed.api.get(`/t/${c.tid}/booking/services/${svc.id}/slots`, { params: { date_from: isoDay(a), date_to: isoDay(b) } });
      setResult({ svc, slots }); toast.success(`Servizio «${svc.name}» creato`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && (result ? onDone(result.svc, f.mode) : onClose())}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="booking-wizard">
        <DialogHeader><DialogTitle>Nuovo servizio prenotabile</DialogTitle>
          <DialogDescription data-testid="wiz-progress">Passo {i + 1} di 4 · {STEPS[i]}</DialogDescription></DialogHeader>
        {i === 0 && <StepType f={f} set={set} askMode={askMode} />}
        {i === 1 && <StepHours f={f} set={set} />}
        {i === 2 && <StepCustomer f={f} set={set} />}
        {i === 3 && <StepSummary f={f} result={result} />}
        <DialogFooter className="gap-2">
          {i > 0 && !result && <Button variant="outline" onClick={() => setI(i - 1)} data-testid="wiz-back">Indietro</Button>}
          {i < 3 && <Button onClick={() => setI(i + 1)} disabled={!ok} data-testid="wiz-next">Avanti</Button>}
          {i === 3 && !result && <Button onClick={save} disabled={busy} data-testid="wiz-save">{busy && <Loader2 size={13} className="mr-1.5 animate-spin" />}Salva servizio</Button>}
          {result && <Button onClick={() => onDone(result.svc, f.mode)} data-testid="wiz-done">Fatto</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>);
}
